/**
 * bbs接口统一管理
 */
import {del, get, post, put} from './http'

/**
 * 用户可见BBS列表
 * @param params
 */
export const getbbslist = (params) => get('goodsmanual/bbs/ent/list', params)


/**
 * 指定商品BBs列表
 * @param params
 */
export const getbbslistbyPro = (params) => get('goodsmanual/bbs/goods/ent/list', params)


/**
 * 添加BBs  postType：1动态2产品故事
 *         contentType  内容类型 1图片 2视频
 * @param params
 */
export const addbbs = (params) => post('goodsmanual/bbs/ent', params)

/**
 * 编辑bbs
 * @param postId
 * @param params
 */
export const editbbs = (postId, params) => put('goodsmanual/bbs/ent/' + postId, params)

/**
 * 获取bbs详情
 * @param id
 */
export const getbbsDetail = (id) => get('goodsmanual/bbs/ent/' + id, {})

/**
 * 批量删除bbs
 * @param params
 */
export const delbbs = (params) => del('goodsmanual/bbs/ent', params)

/**
 * 批量上架
 */
export const approvalbbs = (params) => put('goodsmanual/bbs/shelf', params)

/**
 * 批量下架
 * @param params
 */
export const approvaldownbbs = (params) => put('goodsmanual/bbs/under', params)

/**
 * bbs 置顶
 * @param postId
 * @param params
 */
export const bbsTop = ( params) => put('goodsmanual/bbs/top', params)


